import axios from "axios";

// import ListenIcon from "../assets/images/listen.png";
// import WatchIcon from "../assets/images/watch.png";
// import ChooseIcon from "../assets/images/choose.png";
// import MatchIcon from "../assets/images/match.png";
// import DragIcon from "../assets/images/drag.png";

// import IntroWaterSVG from "../assets/images/cats/introofwater.svg";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function fetchCategories(token, subtopic) {
  try {
    const response = await API.post("/subtopicdata", { token, subtopic });
    // const response = {
    //   data: [
    //     {
    //       id: 1,
    //       name: "Let's Listen and Learn!",
    //       image: ListenIcon,
    //       value: IntroWaterSVG,
    //       type: "PDF",
    //     },
    //     {
    //       id: 2,
    //       name: "Time to Watch and Learn!",
    //       image: WatchIcon,
    //       value: "PREKG GA VIDEOS/WATER/GA_Page 14.mp4",
    //       // value: "https://www.youtube.com/watch?v=gXv0uzLjgNw",
    //       type: "Video",
    //     },
    //     {
    //       id: 3,
    //       name: "Pick the Right One!",
    //       image: ChooseIcon,
    //       value: "https://admin.fefdybraingym.com/admin/chooseup",
    //       type: "Game",
    //     },
    //     {
    //       id: 4,
    //       name: "Can You Find the Match?",
    //       image: MatchIcon,
    //       value: "https://admin.fefdybraingym.com/admin/match",
    //       type: "Game",
    //     },
    //     {
    //       id: 5,
    //       name: "Drag it to the Right Spot!",
    //       image: DragIcon,
    //       value: "https://admin.fefdybraingym.com/admin/drag-drop",
    //       type: "Game",
    //     },
    //   ],
    // };
    return response.data;
  } catch (error) {
    console.error("Error fetching subjects:", error);
    throw error;
  }
}

export { fetchCategories };
